import { getCampaignEdition } from '@geovelo-frontends/commons';
import { Box, Typography } from '@mui/material';
import { useContext } from 'react';

import { AppContext } from '../../app/context';
import bttfOnboarding from '../../assets/img/bttf/bttf-onboarding.png';
import bttfLogo from '../../assets/img/bttf/logo-bttf.svg';
import mockup from '../../assets/img/mockup.png';
// import { CupIcon, FMDIcon, StatsIcon } from '../../components';

function BringTogether({ eventCode: eventCodeProp }: { eventCode?: string }): React.JSX.Element {
  const {
    app: { currentEvent },
  } = useContext(AppContext);
  const eventCode = eventCodeProp ?? currentEvent?.code?.toLowerCase();
  const edition = getCampaignEdition(eventCode);

  if (edition?.illustration) {
    return (
      <Box
        component="img"
        src={edition.illustration}
        sx={{ height: '100svh', width: 'auto', display: 'block', flexShrink: 0 }}
      />
    );
  } else if (eventCode === 'bttf') {
    return (
      <Box
        display="flex"
        flexDirection="column"
        gap={1}
        height="max(100svh, 100%)"
        paddingX={{ xs: 5, lg: 8 }}
        paddingY={5}
        sx={{
          background: `url(${bttfOnboarding})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center left',
          backgroundRepeat: 'no-repeat',
        }}
        width="100%"
      >
        <Typography color="#fff" fontFamily="Poppins" fontSize="18px" fontWeight={700}>
          15 - 28 septembre 2025
        </Typography>
        <Box flexShrink={0}>
          <img src={bttfLogo} width={240} />
        </Box>
        <Typography color="#fff" fontFamily="Poppins" fontSize="16px" fontWeight={600}>
          La ville du futur se construit à vélo !
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={3}
      justifyContent="center"
      minHeight="max(100svh, 100%)"
      paddingX={{ xs: 5, lg: 8 }}
      paddingY={5}
      width="100%"
    >
      <Typography color="#fff" fontSize="1.75rem" fontWeight={600}>
        Se rassembler autour du vélo !
      </Typography>
      <img
        src={mockup}
        style={{ alignSelf: 'center', maxHeight: 'calc(100svh - 150px)', width: 'auto' }}
        width="100%"
      />
    </Box>
  );
}

export default BringTogether;
